import classNames from 'classnames'
import React from 'react'
import { SectorLink } from 'src/components/framework/ui/sector-link'
import { useSecurityContext } from 'src/contexts/security.context'

import * as styles from './breadcrumbs.module.scss'

export const Breadcrumbs: React.FC = () => {
  const { security } = useSecurityContext()

  return (
    <div
      role="navigation"
      className={classNames(
        styles.breadcrumbs,
        'stk-breadcrumbs',
        'enhance-colors',
      )}
      aria-label="Breadcrumbs navigation"
    >
      <a
        className="stk-breadcrumbs__link stk-breadcrumbs__link--trivial"
        href="/"
      >
        Browse
      </a>
      <a
        className="stk-breadcrumbs__link stk-breadcrumbs__link--trivial"
        href="/share-prices"
      >
        Shares
      </a>
      {security.sectors.map((sector) => (
        <SectorLink
          sector={sector}
          className="stk-breadcrumbs__link"
          key={sector.name}
        />
      ))}
      <span className="stk-breadcrumbs__label">{security.name}</span>
    </div>
  )
}
